// src/App.jsx
import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/home/Footer";
import FixedContactButtons from "./components/FixedContactButtons";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Pages
import Home from "./pages/Home";
import CoursesPage from "./pages/CoursesPage";
import AboutPage from "./pages/AboutPage";
import SyllabusPage from "./pages/SyllabusPage";
import PyqPage from "./pages/PyqPage";
import TestSeries from "./pages/TestSeries";
import Daily from "./components/currentaffairs/Daily";
import Daw from "./components/dawpage/DAWPage";
import SubjectDetail from "./components/syllabus/optionalSyllabus/SubjectDetail";

function App() {
  const location = useLocation();

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow">
        <Routes>
          {/* Public Pages */}
          <Route path="/" element={<Home />} />
          <Route path="/courses" element={<CoursesPage />} />
          <Route path="/about-upsc" element={<AboutPage />} />
          <Route path="/syllabus" element={<SyllabusPage />} />
          <Route path="/pyq" element={<PyqPage />} />
          <Route path="/testseries" element={<TestSeries />} />
          <Route path="/current" element={<Daily />} />
          <Route path="/daw" element={<Daw />} />
          <Route
            path="/optional-subject/:subjectName"
            element={<SubjectDetail />}
          />
        </Routes>
      </main>
      <Footer />
      <FixedContactButtons />

      {/* Toast Notifications */}
      <ToastContainer />
    </div>
  );
}

export default App;
